import React from "react";

import ReactDOM from "react-dom/client";

import { Provider } from "react-redux";

import { RouterProvider } from "react-router-dom";

import { store } from "./app/store";
import { router } from "./app/router";

import AuthBootstrap from "./components/auth/AuthBootstrap";
import ToastProvider from "./components/ui/toast/ToastProvider";

import "./styles/reset.css";
import "./styles/variables.css";
import "./styles/global.css";

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <React.StrictMode>
    <Provider store={store}>
      <AuthBootstrap>
        <ToastProvider>
          <RouterProvider router={router} />
        </ToastProvider>
      </AuthBootstrap>
    </Provider>
  </React.StrictMode>,
);
